<script setup lang="ts">
import Card from './@components/Card/index.vue'
import Table from './@components/Table/index.vue'
import { useGetApiKey } from '~~/src/composables/mutations/apiKeys/useGetApiKey'

defineOptions({
  name: 'ApiKeyPage',
})

const { data: apiKeys, isLoading, error, refetch } = useGetApiKey()

const toggleTokenVisibility = (keyId: number) => {
  if (!apiKeys.value)
    return // Verifica se apiKeys.value é undefined

  const key = apiKeys.value.find(apiKey => apiKey.id === keyId)
  if (key)
    key.showToken = !key.showToken
}
</script>

<template>
  <NuxtLayout>
    <template #body-content>
      <div class="md:p-10 !pb-30">
        <div class="mx-auto bg-white md:rounded-10">
          <div class="p-4 md:p-10 flex flex-col gap-6">
            <div class="flex items-center justify-between">
              <HeadingV2 level="2">
                API Keys
              </HeadingV2>

              <NuxtLink to="/api-keys/create">
                <AppButton class="group h-8 md:h-12 !px-4 !md:px-10 <md:flex-1">
                  <HeadingV2 level="5" class="!<sm:text-[14px] color-white opacity-90 group-hover:opacity-100">
                    Create New API Key
                  </HeadingV2>
                </AppButton>
              </NuxtLink>
            </div>

            <div class="flex gap-7 items-center">
              <Text :font-weight="500">
                As the owner of this project, you can view and manage all API keys in this project.
                Do not share your API key with others or expose it in the browser or other client-side code.
              </Text>
            </div>

            <div class="overflow-x-auto">
              <div class="block xl:hidden">
                <Card
                  :api-keys="apiKeys || []"
                  :is-loading="isLoading"
                  :error="error"
                  :toggle-token-visibility="toggleTokenVisibility"
                  @update-keys="refetch"
                />
              </div>

              <div class="hidden xl:block">
                <Table
                  :api-keys="apiKeys || []"
                  :is-loading="isLoading"
                  :error="error"
                  :toggle-token-visibility="toggleTokenVisibility"
                  @update-keys="refetch"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </NuxtLayout>
</template>
